import React, { useState, useEffect } from 'react';
import { Select } from '../ui-kit';
import { orderBy, flatten } from 'lodash';

import GroupName from './GroupName';

const GroupSelector = ({ value, groups, onChange, inputName, isMulti, isClearable }) => {
  // value: supplied as a prop, used when the value is changed externally
  // inputValue: internal state attribute, this will be used when the state
  // change is internal (For example, when the component is injected to a
  // rails view)
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const stations = orderBy(
    groups.filter(g => g.type === 'station'),
    'name'
  );
  const teams = orderBy(
    groups.filter(g => g.type === 'team'),
    'name'
  );

  const options = stations.flatMap(group => {
    const stationLabel = {
      value: group.id,
      label: <GroupName group={group} fullName={true} />,
      textLabel: group.name
    };

    const stationTeams = teams.filter(t => t.parent_group_id === group.id);

    const teamLabels = stationTeams.map(team => ({
      value: team.id,
      label: <GroupName group={team} parentGroup={group} fullName={true} />,
      textLabel: `${group.name} ${team.name}`
    }));

    return [stationLabel, ...teamLabels];
  });

  const selectedValue = isMulti
    ? options.filter(option =>
        flatten([inputValue])
          .map(g => g.id)
          .includes(option.value)
      )
    : options.filter(option => option.value == inputValue);

  const onChangeWrapper = selectedOption => {
    // if there is no inputName supplied, we must
    // use the supplied onChange handler to change
    // the external value
    if (inputName) {
      setInputValue(selectedOption.value);
    }
    // otherwise, we will handle changes internally
    else {
      onChange(selectedOption.value || selectedOption);
    }
  };

  const filterOption = (op, filterValue) => op.data.textLabel.toLowerCase().includes(filterValue.toLowerCase());

  return (
    <React.Fragment>
      {inputName && <input type="hidden" name={inputName} value={inputValue} />}
      <Select
        value={selectedValue}
        onChange={onChangeWrapper}
        options={options}
        isMulti={isMulti || false}
        isClearable={isClearable || false}
        isSearchable={true}
        filterOption={filterOption}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        className="react-select"
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    </React.Fragment>
  );
};

export default GroupSelector;
